export function osPostMessage(os, postData) {
  if (os) os = os.toLowerCase();
  if (process.env.VUE_APP_APP_ID !== 'production' && !postData.includes('INTERACTIVE_PING_ANALYTICS')) {
    console.log(1, os, postData);
  }
  switch (os) {
    case 'iphone':
    case 'ios':
      try {
        window.webkit.messageHandlers.IOS.postMessage(postData);
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
      break;
    case 'androidmobile':
    case 'androidMobile':
    case 'androidtv':
      if (window.Android) {
        try {
          window.Android.postMessage(postData);
        } catch (error) {
          console.log(error);
        }
      } else {
        console.error('window.Android is not defined');
      }
      // try {
      //   window.Android.postMessage(postData);
      // } catch (error) {
      //   console.log(error);
      // }
      break;
    default:
      try {
        window.parent.postMessage(postData, '*');
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
  }
}
